import * as React from 'react';
import * as ReactDom from 'react-dom';
import { useEffect, useState, useContext } from 'react';
import { MessagesContext } from "../common/context";

// import { graph } from '@pnp/graph';
// import { WebPartContext } from "@microsoft/sp-webpart-base";
import { useErrorBoundary } from "use-error-boundary";
import log from 'loglevel';

import * as Fabric from 'office-ui-fabric-react';
import { TextField } from "office-ui-fabric-react";
import { CommandBar} from 'office-ui-fabric-react/lib/CommandBar';

import { escape } from '@microsoft/sp-lodash-subset';
import { PIVOT_KEY } from '../common/consts';

import { RepliesContainer } from "../reply/RepliesContainer";
import { getRepliesAndDispatch } from "../../model/replyService"
import  * as uuidv4 from "uuid/v4";
import {  classNames, messageBarStyle, messageBodyStyle} from "./Message.Styles";

export  function Message({ teamID, channelId, messageId, message, accessToken }) {

    const {dispatch} = useContext(MessagesContext);
    const [isCheckedMR, setIsCheckedMR] = useState(false);
    const [isCheckedM, setIsCheckedM] = useState(false);

    const [showReplies, setShowReplies] = useState(false);
    const [showMessageContent, setShowMessageContent] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);

    const { ErrorBoundary, didCatch, error, errorInfo } = useErrorBoundary();
    log.info(` @ Message`);

    useEffect(() => {
        log.info(`useEffect @ Message`);
        if ( isCheckedM || isCheckedMR) 
        {         
          addItem(message) 
        }
        if ( isCheckedMR ) 
        {         
          getRepliesAndDispatch(teamID, channelId, messageId,accessToken,dispatch)
        }
    }, [isCheckedM,isCheckedMR]);


     const handleToItemsMR = ()=>{
      log.info(`handleToItemsMR @ Message`); 
      setIsCheckedMR(!isCheckedMR); 
    }

    const handleToItemsM = ()=>{
      log.info(`handleToItemsM @ Message`); 
      setIsCheckedM(!isCheckedM); 
    }

    const toggleShowReplies = ()=>{
      log.info(`toggleShowReplies @ Message`); 
      setShowReplies(!showReplies);
  };
  

    const addItem = (item) =>{
      log.info(`addItem @ Message`); 
      const _item = {
        id: uuidv4(),
        date: item.date,
        text : item.text,
        webUrl : item.webUrl,
        user : item.user,
        type : item.type,
        selected: true 
      };
      dispatch({ type: "ADD_MESSAGE", payload: _item });

      const ___payload = { pivotKey:  PIVOT_KEY.ITEMS};
      dispatch({ type: "SET_PIVOT_KEY", payload: ___payload })
    }

    const handleMessageWebUrl = ()=>{
      log.info(`handleMessageWebUrl @ Message`); 
       window.open(message.webUrl, '_blank')
    }


    const nextPage = () =>{
      log.info(`nextPage @ Message`);       
      setPageNumber(pageNumber + 1);
    }  

    const previousPage = () =>{
      log.info(`previousPage @ Message`);       
      const _pageNumber = pageNumber == 1 ? pageNumber : pageNumber -1;
      setPageNumber(_pageNumber);
    }  


    const _items = [
      {
        key: 'perona',
        text: message.user,
        iconOnly: true,
        iconProps: { iconName: 'Contact' },
      },
      {
        key: 'open',
        text: 'Open in Teams',
        iconOnly: true,
        iconProps: { iconName: 'OpenInNewTab' },
        onClick: () => {
          handleMessageWebUrl();
        }
      },
      {
        key: 'title',
        iconProps: { iconName: 'MessageFill' },
        text: `${message.text.replace( /(<([^>]+)>)/ig, '').substr(0,50)}`,
        onClick: () => {setShowMessageContent(!showMessageContent)}
      }
    ];

    const _farItems = [
      {
        key: 'toItemsM',
        text: 'Copy Message to Items',
        iconOnly: true,
        iconProps: { iconName: 'Copy' },
        onClick:  ()=>{ handleToItemsM(); } 
      },
      {
        key: 'toItemsMR',
        text: 'Copy Message and Replies to Items',
        iconOnly: true,
        iconProps: { iconName: 'Copy' },
        onClick:  ()=>{ handleToItemsMR(); } 
      },{
        key: 'previousPage',
        text: 'Previous Page',
        iconOnly: true,
        iconProps: { iconName: 'ChevronLeftMed' },
        onClick:  ()=>{ previousPage() } 
      },
      {
        key: 'showReplies',
        text: `Replies: P-${pageNumber}`,
        onClick:  ()=>{ toggleShowReplies(); } 
      },
      {
        key: 'nextPage',
        text: 'Next Page',
        iconOnly: true,
        iconProps: { iconName: 'ChevronRightMed' },
        onClick:  ()=>{ nextPage(); } 
      } 
    ];
    
    const renderMessageBar=()=>{
      log.info(`renderMessageBar @ Message`);       
      return (
        <ErrorBoundary  
          render={()=>
          <div style={messageBarStyle()} >
            <CommandBar
                    items={_items}
                    farItems={_farItems}
                  />
            </div>
          }
          renderError={({ error, errorInfo }) => <MyErrorComponent error={error} />}  
        />
      );  
    };

    const renderMessage=()=>{
      return (

        showMessageContent ? 
              (
                <ErrorBoundary 
                      render={()=>

                                <div style={messageBodyStyle()} >
                                  {message.text.replace( /(<([^>]+)>)/ig, '')}
                                </div> 
                              }
                      renderError={({ error, errorInfo }) => <MyErrorComponent error={error} />}        
                ></ErrorBoundary>              
              ) : ''
              );  
    };
  
    const MyErrorComponent = ({error})=>{  
      log.error(`MyErrorComponent @ Message error ${error.message}`);
    return (
        <div >Error. Search in Logs for details.</div>
    )
  }

    const renderReplies = () => {
      log.info(`renderReplies @ Message`);       
       
      if (!showReplies) return('')
      return (
        <ErrorBoundary  
            render={()=>
              <RepliesContainer
                  teamId={teamID}
                  channelId={channelId}
                  messageId={messageId}
                  accessToken={accessToken}
                  pageNumber = { pageNumber }
              />}
             renderError={({ error, errorInfo }) => <MyErrorComponent error={error} />}
        >
      </ErrorBoundary>
    ) 
  }        
    return (
      <> 
        { renderMessageBar() }
        { renderMessage() }
        { renderReplies() }        
      </>
    );
}



        {/* {
        activityItemExamples.map((item: { key: string | number }) => (
          <ActivityItem {...item} key={item.key} className={classNames.exampleRoot} />
        ))
        } */}



{/* <span>
<Checkbox
  label={messageContent}
  checked={isChecked}
  onChange={() => {
    onChange();
  }}
></Checkbox>

{message.content}

<div
  onClick={() => {
    toggleShowReplies();
  }}
>
  <h4> Message: {messageContent}</h4>
</div>
</span>
<div> */}


{/* <li key={create_UUID()}>
    <a href={message.webUrl}>{message.content.substr(0,50)} </a>
    </li> */}

// function App() {
//   return (
//     <ThemeProvider theme={muiBaseTheme}>
//       <div>
//         <ChatMessages
        
//           avatar={AVATAR}
//           messages={[
//             "Hi Jenny, How r u today?",
//             "Did you train yesterday",
//             "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Volutpat lacus laoreet non curabitur gravida."
//           ]}
//         />
//         <ChatMessages
//           side={"right"}
//           messages={[
//             "Great! What's about you?",
//             "Of course I did. Speaking of which check this out"
//           ]}
//         />
//         <ChatMessages avatar={AVATAR} messages={["Im good.", "See u later."]} />
//       </div>
//     </ThemeProvider>
//   );
// }



        {/* <TextField
          key={uuidv4()}
          value={message.text}
          readOnly
          resizable={false}
          iconProps={{ iconName: 'Calendar' }}
          onClick={ (event)=>{ 
            console.log(`event` + event)
                    if (event.ctrlKey ) {
                      handleCtrlKey()  
                    } else {
                      toggleShowReplies()
                    }
                  }
                }
          style={messageStyle()}
        />    */}




    // const activityItemExamples = [
    //   {
    //     key: 1,
    //     activityDescription: [
    //       <Link
    //         key={1}
    //         className={classNames.nameText}
    //         onClick={() => {
    //           alert('A name was clicked.');
    //         }}
    //       >
    //        {message.user}
    //       </Link>,
    //       <span key={7}> posted:  </span>,
    //       <Link
    //         key={1}
    //         className={classNames.nameText}
    //         href={message.webUrl}
    //       > 
    //          <Icon iconName={''} />
    //          <Icon iconName={'Message'} /> Teams
    //       </Link>,
  
    //         <Link
    //         key={2}
    //         className={classNames.nameText}
    //         onClick={() => {
    //           toggleShowReplies();
    //         }}
    //       >
    //         <Icon iconName={''} /> 
    //         <Icon iconName={'Message'} /> Replies
    //       </Link>,

    //       <Link
    //         key={3}
    //         className={classNames.nameText}
    //         onClick={() => {
    //           handleCtrlKey();
    //         }}
    //       >
    //         <Icon iconName={''} /> 
    //         <Icon iconName={'Message'} /> Items[M+R]
    //       </Link>




  
    //     ],
    //     activityIcon: <Icon iconName={'Message'} />,
    //     comments: [
    //       <span key={1}>{message.text.replace( /(<([^>]+)>)/ig, '')} </span>,
    //     ]
    //   }
    // ];

    // const messageStyle = () => {
    //     const _style =
    //     {
    //             textDecoration: "",
    //             color: "black",
    //             backgroundColor: "#d2d0ce"

    //         };
    //     return _style;
    // };
